module.exports = __webpack_public_path__ + "img/aviation_mix5.c768f4e9.jpg";